import ACTION_TYPE from '../../store/ACTION_TYPE';
import NOTIFICATION_TYPE from '../../enums/NOTIFICATION_TYPE';
import createReducerFunction from '../../store/reducerCreator';
import t from '../../translations';

let idCounter = 0;

interface State {
    id?: number;
    type?: string;
    text?: string;
    persist?: boolean;
    hiding: boolean;
}

export const initialState: State = {
    hiding: false,
};

interface Action {
    type:
        | ACTION_TYPE.DESTROY_NOTIFICATION
        | ACTION_TYPE.HIDE_NOTIFICATION
        | ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED
        | ACTION_TYPE.APP_SETTINGS_CHANGED_REJECTED
        | ACTION_TYPE.REQUEST_APPS_REJECTED
        | ACTION_TYPE.REQUEST_APP_REJECTED
        | ACTION_TYPE.SUGGEST_APP_REJECTED
        | ACTION_TYPE.SUBMIT_FEEDBACK_FULFILLED
        | ACTION_TYPE.SUBMIT_FEEDBACK_REJECTED
        | ACTION_TYPE.REQUEST_SEARCH_GROUPS_REJECTED
        | ACTION_TYPE.COPY_PERMALINK
        | ACTION_TYPE.ADD_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.REMOVE_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.REMOVE_SIDELOADED_APP_REJECTED
        | ACTION_TYPE.SUGGEST_SETTING_DEFAULT_APP
        | ACTION_TYPE.UPDATE_CUSTOM_DATA_FULFILLED;
    payload: {
        message: string;
    };
}

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        [ACTION_TYPE.DESTROY_NOTIFICATION]: () => initialState,
        [ACTION_TYPE.HIDE_NOTIFICATION]: (state) => ({ ...state, hiding: true }),

        [ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.APP_SETTINGS_CHANGED_REJECTED]: handleRequestRejected,

        [ACTION_TYPE.REQUEST_APPS_REJECTED]: handleRequestRejected,
        [ACTION_TYPE.REQUEST_APP_REJECTED]: handleRequestRejected,
        [ACTION_TYPE.SUGGEST_APP_REJECTED]: handleRequestRejected,

        [ACTION_TYPE.SUBMIT_FEEDBACK_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.SUBMIT_FEEDBACK_REJECTED]: handleRequestRejected,

        [ACTION_TYPE.REQUEST_SEARCH_GROUPS_REJECTED]: handleRequestRejected,

        [ACTION_TYPE.COPY_PERMALINK]: handleRequestFullfilled,

        [ACTION_TYPE.ADD_SIDELOADED_APP_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_REJECTED]: handleRequestRejected,

        [ACTION_TYPE.SUGGEST_SETTING_DEFAULT_APP]: handleRequestInform,

        [ACTION_TYPE.UPDATE_CUSTOM_DATA_FULFILLED]: handleRequestFullfilled,
        [ACTION_TYPE.UPDATE_CUSTOM_DATA_REJECTED]: handleRequestRejected,
    },
});

function handleRequestFullfilled(state: State, { type }: Action) {
    return {
        id: ++idCounter,
        type: NOTIFICATION_TYPE.SUCCESS,
        text: t.notifications[type],
        persist: false,
        hiding: false,
    };
}

function handleRequestRejected(state: State, { payload }: Action) {
    return {
        id: ++idCounter,
        type: NOTIFICATION_TYPE.ERROR,
        text: payload?.message,
        persist: true,
        hiding: false,
    };
}

function handleRequestInform(state: State, { type }: Action) {
    return {
        id: ++idCounter,
        type: NOTIFICATION_TYPE.INFO,
        text: t.notifications[type],
        persist: false,
        hiding: false,
    };
}
